export default {
  data () {
    return {
      mwidth:1024
    }
  },
  mounted () {
    this.setMeasurableSize()
    window.addEventListener('resize', this.setMeasurableSize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setMeasurableSize)
  },
  methods: {
    setMeasurableSize() {
      this.mwidth = window.innerWidth
    }
  }
}